import React from 'react'

import AbsolutePageTemplate from '../../../../components/templates/AbsolutePageTemplate'
import ServiceOrdersLoader from '../_load/ServiceOrderLoader'
import PageHeader from '../_shared/PageHeader'
import PageContent from './PageContent'
import ParentServiceOrderLoader from '../_load/ParentServiceOrderLoader'

const TemplateInternoPropostaPdfPage = ({ id, templateId }) => {
  return (
    <AbsolutePageTemplate>
      <ServiceOrdersLoader id={id}>
        <ParentServiceOrderLoader id={id}>
          <PageHeader templateId={parseInt(templateId)} />
          <PageContent templateId={parseInt(templateId)} />
        </ParentServiceOrderLoader>
      </ServiceOrdersLoader>
    </AbsolutePageTemplate>
  )
}

export default TemplateInternoPropostaPdfPage
